import React from "react"
import * as Yup from "yup"
import {
  Box, ListItem, Stack, Text, UnorderedList,
} from "@chakra-ui/react"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import TextField from "components/ReactHookForm/TextField"

const validationSchema = Yup.object({
  label: Yup.string().trim().required("Please enter a name"),
})

type Props = {
  onClose: () => void
  onSubmit: (label: string) => Promise<void>
}

const CreateApiKeyModal = ({ onClose, onSubmit }: Props) => (
  <ModalForm
    title="Create API Key"
    size="md"
    initialValues={{ label: "" }}
    validationSchema={validationSchema}
    submitText="Generate API Key"
    onClose={onClose}
    onSubmit={({ label }) => onSubmit(label.trim())}
  >
    {({ control }) => (
      <Stack spacing={5}>
        <Text>
          Generate an API key to connect this event to Zapier. Each key is specific to this
          event and can be used across multiple Zaps.
        </Text>
        <TextField
          name="label"
          control={control}
          label="API Key Name"
          labelWeight="semibold"
          placeholder="Enter API Key Name"
          helperText="Enter a descriptive name so it can be easily identified later."
          autoComplete="off"
          variant="outline"
          vertical
          mb={0}
        />
        <Box>
          <Text>Examples:</Text>
          <UnorderedList fontStyle="italic">
            <ListItem>Add Leadership Summit guests to Google Sheets</ListItem>
            <ListItem>Add new registrations to Mailchimp</ListItem>
            <ListItem>Send guest check-ins to Slack</ListItem>
          </UnorderedList>
        </Box>
      </Stack>
    )}
  </ModalForm>
)

export default CreateApiKeyModal
